import { Breadcrumb } from '@components/breadcrumb';
import { cn } from '@utils/helpers';
import { useMemo } from 'react';
import { useFragment } from 'react-relay';
import { SiblingNavigation, TypeMap, contentPageFragment } from './lib';
import type { ContentPagePropsType } from './types';

export const ContentPage: React.FC<ContentPagePropsType> = (props) => {
  const page = useFragment(contentPageFragment, props.page);

  const blockExtraProps = useMemo(() => {
    let logoCount = 0;
    return page.blocks.map((block, index) => {
      switch (block.__typename) {
        case 'LogoBlock':
          return { logoBlockCount: logoCount++ };
        case 'TextBlock':
          return { nextBlock: page.blocks[index + 1] };
        default:
          return undefined;
      }
    });
  }, [page.blocks]);

  return (
    <section className={cn('ContentPage relative mx-auto max-w-[820px] max-[700px]:max-w-[285px]', page.siblingNavigation ? '' : 'content-page-no-nav')}>
      <Breadcrumb data={page.breadcrumbs} />
      {page.blocks.map((block, index) => {
        const ContentBlock = TypeMap[block.__typename];

        if (!ContentBlock) {
          console.warn(`[ContentPage] Unknown block type: ${block.__typename}`);
          return null;
        }

        if (index === 0) {
          return (
            <div className="first-block-nav-wrapper flex justify-between" key={block.__typename}>
              <div className={cn('heading-content-block-wrapper', page.siblingNavigation ? 'with-nav mr-[35px] max-[800px]:mr-0' : '')}>
                {page.title !== '' && <h1 className="mb-[35px]">{page.title}</h1>}
                <ContentBlock contentBlock={block} extraProps={blockExtraProps[index]} />
              </div>
              {page.siblingNavigation && <SiblingNavigation siblingNavigation={page.siblingNavigation} className="self-start max-[800px]:hidden" />}
            </div>
          );
        }

        return <ContentBlock key={block.__typename} contentBlock={block} extraProps={blockExtraProps[index]} />;
      })}
    </section>
  );
};
